import PropTypes from 'prop-types';
import React from 'react';

const FieldPair = ({ children }) => (
	<div className="fieldPair">
		{children}
	</div>
);

FieldPair.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]).isRequired
};

export default FieldPair;
